
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ViewMoreUsers',

  data () {
    return {
      showMore: false,
      hideButton: true
    }
  },

  methods: {
    showMoreUsers: function () {
      this.showMore = true
      this.hideButton = false
    }
  }

})
